<div class="vertical-line">|</div>
